import storage from 'redux-persist/lib/storage';

export const persistConfig = {
    key: 'root',
    storage,
    // List of things we do want persisting, to avoid unexpected side effects we use a whitelist rather than a blacklist here.
    whitelist: ['cache']
};
